<template>
  <div>
    <v-row
      v-if="prop != null"
      class="ma-0 pa-0 px-4"
      v-bind:class="classes"
      :justify="prop === '(OUX)' || prop === '(+)' ? 'center' : 'start'"
    >
      <v-icon
        small
        v-if="prop === 'setaz' || prop === 'setax'"
        class="ml-n1 ma-0 pa-0"
        color="primary"
        >{{ mdiArrowDownBold }}</v-icon
      >
      <v-icon
        small
        v-else-if="prop === '(+)'"
        class="ma-0 pa-0"
        color="primary"
        >{{ mdiPlus }}</v-icon
      >
      <p
        v-else-if="prop === '(OUX)'"
        v-html="'<b>ou</b>'"
        class="ma-0 pa-0"
      ></p>
      <p v-else v-html="prop" class="ma-0 pa-0"></p>
    </v-row>
    <slot></slot>
  </div>
</template>

<style>
.section-paragraph {
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  line-height: 16px;
  color: #393a3a;
}
.section-paragraph-result {
  width: 100%;
  font-size: 18px;
  font-weight: normal;
  color: #393a3a;
}
</style>

<script>
import { mdiArrowDownBold, mdiPlus } from "@mdi/js";
export default {
  name: "SectionParagraph",
  props: {
    prop: {
      type: String,
    },
    result: {
      type: Boolean,
      default: false,
      required: false,
    },
    color: {
      type: String,
      default: "",
      required: false,
    },
  },
  computed: {
    classes() {
      return `${this.color}--text ${
        this.result ? "section-paragraph-result" : "section-paragraph"
      }`;
    },
  },
  data() {
    return { mdiArrowDownBold, mdiPlus };
  },
  created() {},
};
</script>